import { render } from "./UploadedImage.vue?vue&type=template&id=83e6d0d2&scoped=true"
import script from "./UploadedImage.vue?vue&type=script&lang=js"
export * from "./UploadedImage.vue?vue&type=script&lang=js"

import "./UploadedImage.vue?vue&type=style&index=0&id=83e6d0d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83e6d0d2"]])

export default __exports__